"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorsAndWarnings = exports.isRepeatDetailBarVisible = exports.getAllowInitialDataDelete = exports.getAllowAdding = exports.getRepeatsEnabled = exports.getDeleteConfirmationMessage = exports.isReorderingAllowed = exports.getAddButtonText = exports.getRepeatMax = exports.getRepeatMin = exports.isComponentConditional = void 0;
const gen5_shared_utilities_1 = require("@terragotech/gen5-shared-utilities");
const isComponentConditional = (controlDefinition) => {
    return !!controlDefinition.conditionalMap;
};
exports.isComponentConditional = isComponentConditional;
const getRepeatMin = (controlDefinition) => {
    var _a;
    return ((_a = controlDefinition.repeats) === null || _a === void 0 ? void 0 : _a.min) || 0;
};
exports.getRepeatMin = getRepeatMin;
const getRepeatMax = (controlDefinition) => {
    var _a;
    return ((_a = controlDefinition.repeats) === null || _a === void 0 ? void 0 : _a.max) || -1;
};
exports.getRepeatMax = getRepeatMax;
const getAddButtonText = (controlDefinition) => {
    var _a;
    return ((_a = controlDefinition.repeats) === null || _a === void 0 ? void 0 : _a.addButtonText) || 'Add';
};
exports.getAddButtonText = getAddButtonText;
const isReorderingAllowed = (controlDefinition) => {
    return false; //controlDefinition.repeats?.allowReordering || false;
};
exports.isReorderingAllowed = isReorderingAllowed;
const getDeleteConfirmationMessage = (controlDefinition) => {
    var _a;
    return ((_a = controlDefinition.repeats) === null || _a === void 0 ? void 0 : _a.deleteConfirmationMessage) || 'Are you sure you would like to delete this item?';
};
exports.getDeleteConfirmationMessage = getDeleteConfirmationMessage;
const getRepeatsEnabled = (controlDefinition) => {
    var _a;
    return ((_a = controlDefinition.repeats) === null || _a === void 0 ? void 0 : _a.enabled) || false;
};
exports.getRepeatsEnabled = getRepeatsEnabled;
const getAllowAdding = (controlDefinition) => {
    var _a;
    return ((_a = controlDefinition.repeats) === null || _a === void 0 ? void 0 : _a.allowAdding) || false;
};
exports.getAllowAdding = getAllowAdding;
const getAllowInitialDataDelete = (controlDefinition) => {
    var _a;
    return ((_a = controlDefinition.repeats) === null || _a === void 0 ? void 0 : _a.allowInitialDataDelete) || false;
};
exports.getAllowInitialDataDelete = getAllowInitialDataDelete;
const isRepeatDetailBarVisible = (repeatable, index, itemCount, repeatCollapsed) => repeatable && (repeatCollapsed || index === itemCount - 1);
exports.isRepeatDetailBarVisible = isRepeatDetailBarVisible;
const getErrorsAndWarnings = (errors, warnings, fieldLevelWarnings) => {
    const formErrors = [];
    const formWarnings = [];
    const fieldErrors = [];
    const fieldWarnings = [];
    if (errors) {
        const flattenErrors = (0, gen5_shared_utilities_1.flattenObject)(errors);
        Object.keys(flattenErrors).forEach(errorKey => {
            // form groups return an object with errors in it.
            const message = flattenErrors[errorKey];
            // Filter out all field-level errors. Form level ones have a number string as a key (it gets assigned in FormRootRenderer in FormRenderer )
            if (/^\d+$/.test(errorKey)) {
                formErrors.push(message);
            }
            else
                fieldErrors.push(message); // for field errors we save fieldnames for required fields alert
        });
    }
    if (warnings) {
        const flattenWarnings = (0, gen5_shared_utilities_1.flattenObject)(warnings);
        Object.keys(flattenWarnings).forEach(warningKey => {
            const message = warnings[warningKey];
            // in warnings returned by render() there will be only form warnings
            formWarnings.push(message);
        });
    }
    if (fieldLevelWarnings) {
        const flattenFieldLevelWarnings = (0, gen5_shared_utilities_1.flattenObject)(fieldLevelWarnings);
        Object.keys(flattenFieldLevelWarnings).forEach(warningKey => {
            const message = fieldLevelWarnings[warningKey];
            // in warnings returned by render() there will be only form warnings
            fieldWarnings.push(message);
        });
    }
    return {
        formErrors,
        fieldErrors,
        formWarnings,
        fieldWarnings,
    };
};
exports.getErrorsAndWarnings = getErrorsAndWarnings;
//# sourceMappingURL=FormRendererHelpers.js.map